import bolide_assistant_history_item from "./BolideAssistantHistoryItem/BolideAssistantHistoryItem.vue";

export default {
  name: "BolideAssistantHistory",

  components: {
    BolideAssistantHistoryItem: bolide_assistant_history_item,
  },

  props: {
    conversations: {
      type: Array,
      default: () => [],
    },
    active_conversation_id: {
      type: String,
      default: null,
    },
    is_open: Boolean,
    has_more_conversations: Boolean,
    is_loading_conversations: Boolean,
  },

  emits: [
    "new-conversation",
    "select-conversation",
    "delete-conversation",
    "load-more-conversations",
  ],

  computed: {
    ordered_conversations() {
      return [...this.conversations].sort((a, b) => {
        return new Date(b.updated_at || b.created_at) - new Date(a.updated_at || a.created_at);
      });
    },
  },

  methods: {
    handle_scroll(event) {
      if (!this.has_more_conversations || this.is_loading_conversations) return;
      const element = event.currentTarget;
      const distance_to_bottom = element.scrollHeight - element.scrollTop - element.clientHeight;
      if (distance_to_bottom < 80) this.$emit("load-more-conversations");
    },
  },
};
